import React, { Component } from "react";

class RadioBtn extends Component {
  render() {
    return (
      <div className="col-12 mt-3 px-0">
        <div
          className="rounded14 border p-3"
          onClick={() => this.props.address_change(this.props.address.uid)}
        >
          <input
            class="form-check-input mt-0 align-middle color-second"
            type="radio"
            name="exampleRadios"
            value={this.props.address && this.props.address.uid}
            checked={this.props.checked}
          />
          <label class="form-check-label me-3 fw-bolder" for="defaultCheck1">
            {this.props.address && this.props.address.address}
            {this.props.name && this.props.name}
          </label>
        </div>
      </div>
    );
  }
}

export default RadioBtn;
